export default __webpack_public_path__ + "static/media/iCashPayScreenLogo.5fe9c4ee.svg";